import React from 'react'

// ArComponents
import ArHeroHeader from 'src/components/ArHeroHeader/ArHeroHeader'
import ArTextWithImage from 'src/components/ArTextWithImage/ArTextWithImage'
import ArTextWithImageStacked from 'src/components/ArTextWithImageStacked/ArTextWithImageStacked'
import ArCTASection from 'src/components/ArCTASection/ArCTASection'
import ArDocumentColumns from 'src/components/ArDocumentColumns/ArDocumentColumns'
import ArAnimation from 'src/components/ArAnimation/ArAnimation'
import ArPartners from 'src/components/ArPartners/ArPartners'
import ArTestimonials from 'src/components/ArTestimonials/ArTestimonials'
import ArSeo from 'src/components/ArSeo/ArSeo'

// Data
import DaPageProductBuildData from 'src/data/PageProductBuild'
import DaDataCommon from 'src/data/DataCommon'
import routesConfig from 'src/routes.config'

export default class ProductsBuildPage extends React.Component {
  render () {
    return (
      <React.Fragment>
        <ArSeo
          title={DaPageProductBuildData.metadata.title}
          description={DaPageProductBuildData.metadata.desc}
          path={routesConfig.useCases.transformData()}
        />

        {(() => {
          const { image, title, description, cta, animation } = DaPageProductBuildData.ArHeroHeader
          return (
            <div style={ { overflow: 'hidden' } }>
              <ArHeroHeader
                variant="product-build"
                title={title}
                description={description}
                cta={cta}
                scImageLeft={true}
                scGap={100}
                animationComponent={<ArAnimation animation={animation} />}
              />
            </div>
          )
        })()}

        {(() => {
          const { items } = DaPageProductBuildData.ArTextWithImage

          return items.map(({ title, description, images, scImageMargins, scComponentMargins, scGap, scFlexAlign, scTitleMaxWidth }, index) =>
            <ArTextWithImage
              key={index}
              images={images}
              title={title}
              description={description}
              scImageToRight={!!((index + 1) % 2)}
              scImageMargins={scImageMargins}
              scComponentMargins={scComponentMargins}
              scGap={scGap}
              scFlexAlign={scFlexAlign}
              scTitleMaxWidth={scTitleMaxWidth}
            />
          )
        })()}

        {(() => {
          const { items } = DaPageProductBuildData.ArTextWithImageStacked

          return items.map(({ title, description, images, animation, ...scRest }, index) =>
            <ArTextWithImageStacked
              key={index}
              images={images}
              title={title}
              description={description}
              scImageToRight={!((index + 1) % 2)}
              scImageOnEdge={index === items.length - 1}
              scBigHeadingOnTablet={true}
              animation={animation}
              { ...scRest }
            />
          )
        })()}

        {(() => {
          const { columns } = DaPageProductBuildData.ArDocumentColumns

          return (
            <ArDocumentColumns columns={columns} />
          )
        })()}

        <ArPartners {...DaDataCommon.ArPartners} />

        <ArTestimonials testimonials={DaDataCommon.ArTestimonials} />

        {(() => {
          const { title, cta, backgroundColor } = DaPageProductBuildData.ArCTASection

          return (
            <ArCTASection title={title} cta={cta} scBackgroundColor={backgroundColor} />
          )
        })()}
      </React.Fragment>
    )
  }
}
